export const CSRF_REQUEST = "CSRF_REQUEST";